import { Tag } from 'apprise-core/tag'
import { usePreload } from 'apprise-frontend-core/client/preload'
import { tagservice, useTagService } from 'apprise-frontend-tags/service'

export const etagapi = "/etag"

export const useExternalTagCalls = () => {

    const service = useTagService()

    const preload = usePreload()

   const self = {

        fetchTagsInCategory: (category : string) => preload.get<Tag[]>(`${etagapi}/${category}`) ?? service.at(`${etagapi}/${category}`,tagservice).get<Tag[]>()

    }

    return self;

}
